// extracted by mini-css-extract-plugin
export default {"container":"eIHB2p","nav":"HoOG3A","sectionHeading":"eeSr0i","scrollElement":"WZ9uiF","cta":"EXpL88"};